import React, { useState } from "react";
import { Switch } from "antd";
import moment from "moment";
import Table_Icon from "../../../../assets/images/table.svg";
import Packet_Icon from "../../../../assets/images/packet.svg";
import Bike_Icon from "../../../../assets/images/bike.svg";

const cardClass = {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
};
const orderType = {
  POS: Table_Icon,
  ONLINE_DELIVERY: Bike_Icon,
  ONLINE_TAKEOUT: Packet_Icon,
  ONLINE_CATERING: Packet_Icon,
};
const Card = (props) => {
  const { cardData, expoGroup = "HIGH", handleUpdateCartItem } = props;

  const [readyToDispatchItemIds, setReadyToDispatchItemIds] = useState(
    new Set(
      cardData
        .filter((item) => item.kitchen_priority === "READY")
        .map((item) => item.id)
    )
  );

  const handleSwitchChange = (checked, item) => {
    if (checked) {
      setReadyToDispatchItemIds(currentVal => {
        const updatedSet = new Set(currentVal).add(item.id);
        return updatedSet;
      });
      try {
        handleUpdateCartItem(item, {
          kitchen_priority: "READY"
        });
      } catch (error) {
        setReadyToDispatchItemIds(currentVal => {
          const updatedSet = new Set(currentVal);
          updatedSet.delete(item.id);
          return updatedSet;
        });
      }
    } else {
      setReadyToDispatchItemIds(currentVal => {
        const updatedSet = new Set(currentVal);
        updatedSet.delete(item.id);
        return updatedSet;
      });
      try {
        handleUpdateCartItem(item, {
          kitchen_priority: "MEDIUM"
        });
      } catch (error) {
        setReadyToDispatchItemIds(currentVal => {
          const updatedSet = new Set(currentVal).add(item.id);
          return updatedSet;
        });
      }
    }
  };

  const firstOrder = cardData[cardData.length - 1];

  if (!cardData.length) {
    return null;
  }

  return (
    <div className="expo_card">
      <div className={"head_title " + cardClass[expoGroup]}>
        <div>
          <img src={orderType[firstOrder.cart.order_type]} alt="" />
        </div>
        <div>{moment(firstOrder.updated_at).fromNow()}</div>
      </div>
      <div className="card_content">
        {cardData.map((item, idx) => (
          <div className="content_item" key={item.menu_item.id}>
            <div className="content_rowtext">
              <div>{item.quantity}</div>
              <div className="cross">x</div>
              <div className="item_name">
                <div className="name_row">
                  <div>{item.menu_item.name}</div>
                  <div>
                    <Switch
                      size="small"
                      onChange={(checked) => handleSwitchChange(checked, item)}
                      checked={readyToDispatchItemIds.has(item.id)}
                    />
                  </div>
                </div>
                <p className="item_info">Note:</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Card;
